import { cnBem } from '@carnica/utils';
import themeV1 from "./themeV1.pcss";
import themeV2 from "./themeV2.pcss";
export { theme as themeV1 } from "./themeV1";
export { theme as themeV2 } from "./themeV2";
export var cnComponentsTheme = function cnComponentsTheme(theme, version) {
  return cnBem('theme', version === 'v2' ? themeV2 : themeV1)({
    theme: theme !== null && theme !== void 0 ? theme : 'light'
  });
};